/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentServerConnection,
  AgentServerConnection$inboundSchema,
} from "./agentserverconnection.js";

export type GetMyConnectionsResult = {
  /**
   * One entry per distinct MCP server in the plugins delivered to the user, in plugin order. Servers the user can neither read nor connect to are omitted; a server the user can read but not connect to is reported as no_access.
   */
  servers: Array<AgentServerConnection>;
};

/** @internal */
export const GetMyConnectionsResult$inboundSchema: z.ZodMiniType<
  GetMyConnectionsResult,
  unknown
> = z.object({
  servers: z.array(AgentServerConnection$inboundSchema),
});

export function getMyConnectionsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetMyConnectionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMyConnectionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMyConnectionsResult' from JSON`,
  );
}
